import React from 'react';
import base44SocialProofMobile0 from '../../assets/images/base44SocialProofMobile0.webp';
import base44SocialProofMobile1 from '../../assets/images/base44SocialProofMobile1.webp';
import base44SocialProofMobile2 from '../../assets/images/base44SocialProofMobile2.webp';
import base44SocialProofMobile3 from '../../assets/images/base44SocialProofMobile3.webp';
export const Base44SocialProofMobileSvg = () => /*#__PURE__*/React.createElement("svg", {
  width: "100%",
  height: "400",
  viewBox: "0 0 343 400",
  preserveAspectRatio: "xMidYMid slice",
  fill: "none",
  style: {
    display: 'block'
  },
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, /*#__PURE__*/React.createElement("image", {
  href: base44SocialProofMobile0,
  x: "6",
  y: "-4",
  width: "140",
  height: "106",
  preserveAspectRatio: "xMidYMid slice"
}), /*#__PURE__*/React.createElement("image", {
  href: base44SocialProofMobile2,
  x: "250",
  y: "6",
  width: "118",
  height: "115",
  preserveAspectRatio: "xMidYMid slice"
}), /*#__PURE__*/React.createElement("image", {
  href: base44SocialProofMobile3,
  x: "-8",
  y: "268",
  width: "150",
  height: "142",
  preserveAspectRatio: "xMidYMid slice"
}), /*#__PURE__*/React.createElement("image", {
  href: base44SocialProofMobile1,
  x: "196",
  y: "286",
  width: "165",
  height: "100",
  preserveAspectRatio: "xMidYMid slice"
}));
//# sourceMappingURL=Base44SocialProofMobileSvg.js.map